import { useCallback, useSyncExternalStore } from 'react';
import {
  abrirDialogoNativo,
  constaInstalada,
  hayInstalacionNativa,
  suscribir,
} from '../lib/installPrompt';

export interface UseInstallPromptReturn {
  /** El navegador tiene una oportunidad de instalación nativa disponible ahora. */
  readonly puedeInstalarNativo: boolean;
  /** Consta que la app está instalada en este equipo. Siempre false en iOS. */
  readonly yaInstalada: boolean;
  /** Abre el diálogo nativo. false ⇒ el llamador debe mostrar los pasos manuales. */
  readonly instalar: () => Promise<boolean>;
}

export function useInstallPrompt(): UseInstallPromptReturn {
  const puedeInstalarNativo = useSyncExternalStore(suscribir, hayInstalacionNativa, () => false);
  const yaInstalada = useSyncExternalStore(suscribir, constaInstalada, () => false);
  const instalar = useCallback(() => abrirDialogoNativo(), []);

  return { puedeInstalarNativo, yaInstalada, instalar };
}
